import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';

// Async action to fetch people
export const fetchPeople = createAsyncThunk(
  'filter/fetchPeople',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const token = await UserProfile.getToken();
      const response = await axios.get(`${apiUrl}admin/kpis/people_per_teams`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: filters, // Filters should include "quarter"
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice for managing people data
const peopleSlice = createSlice({
  name: 'people',
  initialState: {
    people: null,          // All fetched people
    loading: false,      // Loading state
    error: null,         // Error state
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPeople.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPeople.fulfilled, (state, action) => {
        state.loading = false;
        state.people = action.payload; // Store the list of people
      })
      .addCase(fetchPeople.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default peopleSlice.reducer;
